import { EventTrackingProvider } from "@newsela/snitch";
import PropTypes from "prop-types";

import useUser from "@/users/useUser";
import useGetPreviousUrl from "../useGetPreviousUrl";
import type { ReactNode } from "react";

const OWN_HOST = process.env["NEXT_PUBLIC_SER_DAVOS_URL"] || "";
const SER_DAVOS_URL =
  process.env["NEXT_PUBLIC_SER_DAVOS_URL"] || `${OWN_HOST}/ser-davos`;
const propTypes = {
  children: PropTypes.node,
};

const EventTrackingProviderSnitch = ({ children }: { children: ReactNode }) => {
  const { data: user } = useUser();
  const getPreviousUrl = useGetPreviousUrl();
  return (
    <EventTrackingProvider
      userInfo={{ userId: user?.id, uniqueUserId: user?.unique_id }}
      getPreviousUrl={getPreviousUrl}
      platform="lyceum"
      snitchEndpoint={`${SER_DAVOS_URL}/ferry`}
    >
      {children}
    </EventTrackingProvider>
  );
};

EventTrackingProviderSnitch.propTypes = propTypes;

export default EventTrackingProviderSnitch;
